import * as angular from "angular";
import {IController, IScope, ITimeoutService} from "angular";
import * as _ from "lodash";
import {BillingOrderService} from "../../services/billing-order.service";
import {BillingOrderStatusType} from "../../types/billing-order-status.type";
import {OmsService} from "../../../oms/services/oms-service.service";
import {BillingAlertsService} from "../../services/billing-alerts.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {SplitService} from "../../../commons/services/split-service.service";

export class BillingOrderPanelCtrl implements IController {

  billingOrder: any;
  isEditMode: boolean;
  isShowCloseButton?: boolean;
  isActionsDisabled?: boolean;
  onEdit: Function;
  onClose: Function;
  onCreateInvoice: Function;
  onDeleteInvoice: Function;

  public billingOrderPriceOffer: any;
  public billingOrderPriceOfferCopy: any;
  public isUpdateAvailable: boolean = false;
  public orderInfo: any;
  public isBillingTabOpen: boolean = true;
  public billingOrderStatusType: typeof BillingOrderStatusType = BillingOrderStatusType;

  private loading = false;

  constructor(private omsService: OmsService, private billingOrderService: BillingOrderService, private billingAlertsService: BillingAlertsService,
              private commonsAlertsService: CommonsAlertsService, private $timeout: ITimeoutService, private confirmDialogService: ConfirmDialogService,
              private $log, private fileDownloader, private $scope: IScope, private $billingOrders, private splitService: SplitService) {
  }

  $onInit() {

    this.$billingOrders(this.billingOrder.id).$bindCtrl(this.$scope, this, 'billingOrder');

    if (_.get(this.billingOrder, 'orderId')) {
      this.billingOrderService.getPrice(this.billingOrder.id)
        .then(priceOffer => {
          this.billingOrderPriceOffer = priceOffer;
          this.billingOrderPriceOfferCopy = angular.copy(this.billingOrderPriceOffer);
        });
    }

  }

  $onChanges(changes) {
    if (changes.billingOrder && !changes.billingOrder.isFirstChange()) {
      this.$onInit();
    }
    if (changes.isEditMode && !changes.isEditMode.isFirstChange()) {
      this.billingOrderPriceOfferCopy = angular.copy(this.billingOrderPriceOffer);
    }
  }

  onOpen($mdMenu, ev) {
    this.$timeout(0).then(() => {
      $mdMenu.open(ev);
    });
  }

  onUpdateAdditions() {
    this.billingOrderService.syncPrice(this.billingOrder.id)
      .then(response => {
        this._updateAdditions(response);
      })
  }

  onMarkAsPaid($event) {
    const title = 'Mark as Paid',
      textContent = `MARK_AS_PAID_CONTENT_CONFIRM`,
      extraContent = 'Note that this action can not be reversed!';

    this.confirmDialogService.confirmWithInfo(title, textContent, extraContent, {billingOrderId: this.billingOrder.id}, $event)
      .then(() => {
        this._markAsPaid(this.billingOrder.id);
      })
      .finally(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onPriceOfferChange(updatedPriceOffer) {
    this.billingOrderPriceOfferCopy = updatedPriceOffer;
  }

  onUpdatePriceOffer(form) {
    form.$setSubmitted(true);
    if (form.$valid) {
      this.loading = true;
      this.billingOrderService.updatePrice(this.billingOrder.id, this.billingOrderPriceOfferCopy, true)
        .then((priceOffer) => {
          this.billingOrderPriceOffer = priceOffer;
          this.onEdit({isEdit: false});
        }).finally(() => {
          this.loading = false;
      })
    } else {
      this.commonsAlertsService.formInvalidInfo();
    }
  }

  onToggleTab() {
    this.isBillingTabOpen = !this.isBillingTabOpen;
    if (!this.isBillingTabOpen && !this.orderInfo) {
      this._getOrderInfo();
    }
  }

  onChangeModeToEdit() {
    this.isBillingTabOpen = true;
    this.onEdit({isEdit: true});
  }

  onInvoiceDownload() {
    this.billingOrderService.getBillingOrderInvoice(this.billingOrder.id).then((res) => {
      let fileName = res.headers('content-disposition').split('filename = ')[1];
      this.fileDownloader(res.data, fileName, _.get(res.headers(), "content-type"))
    });
  }

  onConsolidateInvoiceDownload(consolidateInvoiceId) {
    this.billingOrderService.getBillingOrderConsolidateInvoice(consolidateInvoiceId).then((res) => {
      this.fileDownloader(res.data, consolidateInvoiceId, _.get(res.headers(), "content-type"))
    });
  }

  private _getOrderInfo() {
    this.omsService.getOrderInfo(this.billingOrder.orderId)
      .then(info => {
        this.orderInfo = info;
      })
  }

  private _markAsPaid(billingOrderId) {
    this.billingOrderService.manualPaid(billingOrderId)
      .then(response => {
        this.billingOrder = response;
      });
  }

  private _updateAdditions(data) {
    const billingOrderPriceOfferCopy = angular.copy(this.billingOrderPriceOffer);
    _.forEach(data.pricingDataInfos, (updatedLine) => {
      const line = _.find(billingOrderPriceOfferCopy.pricingDataInfos, (prevLine) => {
        return prevLine.fulfillmentLineId === updatedLine.fulfillmentLineId;
      });
      if (!_.get(line, 'priceDetails.finalAdditionLines')) {
        line.priceDetails.finalAdditionLines = []
      }
      const updates = _.uniqBy(updatedLine.priceDetails.finalAdditionLines.concat(line.priceDetails.finalAdditionLines), 'id');
      if (updates.length) {
        this.isUpdateAvailable = true;
      }
      line.priceDetails.finalAdditionLines = updates;
    })
    this.billingOrderPriceOffer = billingOrderPriceOfferCopy;
    this.isUpdateAvailable ? this.billingAlertsService.syncPriceOfferSuccess() : this.billingAlertsService.syncPriceOfferNoUpdateAvailableWarning();
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .component('billingOrderPanel', {
    bindings: {
      billingOrder: '<',
      isEditMode: '<',
      isShowCloseButton: '<?',
      isActionsDisabled: '<?',
      onClose: '&',
      onEdit: '&',
      onCreateInvoice: '&',
      onDeleteInvoice: '&'
    },
    template: require('./billing-order-panel.html').default,
    controller: BillingOrderPanelCtrl
  });
